<app-banner></app-banner>
<section class="app-container">
  <router-outlet></router-outlet>
</section>
<footer class="app-footer">
  <span class="app-footer-wifi" [class.app-footer-wifi--offline]="!isOnline()" title="{{ isOnline() ? 'Network connected' : 'No network connection' }}">
    <fa-icon icon="wifi"></fa-icon>
    @if (!isOnline()) {
      <fa-icon class="app-footer-wifi-ban" icon="ban"></fa-icon>
    }
  </span>
  <fa-icon icon="copyright"></fa-icon> 2026  PlatePath - {{ tenantName() }}
</footer>